// extracted by mini-css-extract-plugin
export default {"noteContainer":"Style_noteContainer__ypu6o","noteAdded":"Style_noteAdded__yki4V","addNote":"Style_addNote__lUKD5"};